import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import BGVideo from '../layout/BGVideo';
import Default from './Default';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import gsap, { Expo, Power4 } from 'gsap';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { isSmartphone } from '../_app/cuchillo/core/Basics';

export default class About extends Default {
   
  smoothMobile = true;

//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this.scrollbarFake = GetBy.class("scrollbar-fake", this.container)[0];
  }

  beforeShow() {
    Header.closeHeader();
    super.beforeShow();
    Scroll.goto(0);

    if(this.scrollbarFake) {
      const bar = GetBy.class("bar", this.scrollbarFake);
      gsap.to(bar, {y:0, scaleY:1, duration:1.2, ease:Expo.easeIn});
    }
  }

  show__effect(__call) {
    if(isSmartphone) Scroll.goto(1);
    super.show__effect(__call);
  }

  hide__effect() {
    Footer.hide();
    super.hide__effect();
  }

  afterHide() {
    super.afterHide();
  }

  loop() {
    if(this.scrollbarFake) this.scrollbarFake.style.setProperty('--progress', Scroll?.engine?.progress * 4);
  }
}

ControllerPage._addPage("page-about", About)
